module.exports = __webpack_public_path__ + "img/file-share-line.32c5c641.svg";